import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param user UserModel
 * @return {Promise<any>|Promise}
 */
export default (function (user) {
    var url = applyPathVariables(EndPoints.REGISTER, {});
    var request = new Request({ method: Methods.POST, url: url, withCredentials: false, data: user });
    return request.execute();
});
